import React, {useCallback, useMemo} from "react"

import {useMutation, useQuery} from "@tanstack/react-query";
import {useContext, useState} from "react";

import {useForm, useWatch} from "antd/lib/form/Form";
import {Button, Col, Collapse, Divider, Empty, Flex, Form, Grid, Input, Modal, notification, Popconfirm, Row, Select, Tag, Tooltip, Popover, Dropdown, Space} from "antd"

import {NovasInscricoes} from "./NovasInscricoes";
import {Conjunto} from "../../../../../Components/Conjunto";
import {DescricaoDaViagem} from "../Componentes/DescricaoDaViagem";
import {DescricaoDoAluno} from "../Componentes/DescricaoDoAluno";
import {DescricaoDoResponsavel} from "../Componentes/DescricaoDoResponsavel";
import {EnumStatusDaInscricaoDoAlunoNaViagem, StatusDaInscricaoDoAlunoNaViagemLista} from "../../../../../Models/Domain/Viagem/Enum";
import {Formatacoes} from "../../../../../Utils/Formatacao";
import {DownloadOutlined, DownOutlined, MinusOutlined, PlusOutlined} from "@ant-design/icons";
import {Ordenar} from "../../../../../Utils/Ordenacao";
import {Permissoes} from "../../../../../Constants/Permissoes";
import {PropriedadesDeNotificacao} from "../../../../../Utils/Notificacoes";
import {ResponsiveAntdTable} from "../../../../../Components/ResponsiveAntdTable";
import {Restrito} from "../../../../../Components/Restrito";
import {TypeAluno} from "../../../../../Models/Domain/Pessoa/Aluno";
import {_TypeInscricaoDoAlunoNaViagemSemRecursao, TypeInscricaoDoAlunoNaViagem} from "../../../../../Models/Domain/Viagem/InscricaoDoAlunoNaViagem";
import {TypeViagem} from "../../../../../Models/Domain/Viagem/Viagem"
import {ViagemService} from "../../../../../Services/Domain/Viagem/ViagemService";
import {SessaoContext} from "../../../../../Contexts/SessaoContext";

import { FichaDeSaudeModal } from "@/Views/FichaDeSaude/Ficha";
import { AutorizacaoDaViagemModal } from "@/AreaRestritta/Components/Manager/AutorizacaoDaViagem/AutorizacaoDaViagem";

import dayjs from "dayjs"
import useModal from "antd/es/modal/useModal";
import GerarLinkPagamentoFormPopConfirm from "@/Components/Populados/Viagem/Inscricao/LinkPagamentoInscricao/GerarLinkPagamentoFormPopConfirm";
import { TituloPagamentoListPorTitulo } from "@/Components/Populados/Financeiro/Titulo/Pagamento/TituloPagamentoList";
import { useObterFichaDeSaudeAlunoZip } from "@/Services/Domain/Documentos/DocumentoService";
import { saveAs } from "file-saver";
import InscricaoProvedorPgtoFormPopConfirm from "@/Components/Populados/Viagem/Inscricao/InscricaoProvedorPgto/InscricaoProvedorPgtoPopConfirm";

export const obterTagDoStatus = (v: EnumStatusDaInscricaoDoAlunoNaViagem): JSX.Element => {
    const style: React.CSSProperties = {
        width: "fit-content",
        textWrap: "pretty"
    }

    switch (v) {
        case EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_INSCRICAO:
            return <Tag style={style} color="default">Aguardando inscrição</Tag>;

        case EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_PAGAMENTO:
            return <Tag style={style} color="yellow">Aguardando pagamento</Tag>

        case EnumStatusDaInscricaoDoAlunoNaViagem.INSCRITO_E_PAGO:
            return <Tag style={style} color="green">Inscrito e pago</Tag>

        case EnumStatusDaInscricaoDoAlunoNaViagem.CANCELADO:
            return <Tag style={style} color="red">Cancelado</Tag>
    }
}

export const obterTagDoStatusString = (v: EnumStatusDaInscricaoDoAlunoNaViagem): string => {
    switch (v) {
        case EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_INSCRICAO:
            return "Aguardando inscrição";

        case EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_PAGAMENTO:
            return "Aguardando pagamento";

        case EnumStatusDaInscricaoDoAlunoNaViagem.INSCRITO_E_PAGO:
            return "Inscrito e pago";

        case EnumStatusDaInscricaoDoAlunoNaViagem.CANCELADO:
            return "Cancelado";
    }
}

export const AlterarStatus: React.FC<{ codViagem: number; codInscricao: number; statusInicial?: EnumStatusDaInscricaoDoAlunoNaViagem; onSuccess?: () => void }> = ({
    codViagem,
    codInscricao,
    statusInicial,
    onSuccess,
}) => {
    const [status, setStatus] = useState<EnumStatusDaInscricaoDoAlunoNaViagem>();
    const [modal, modalCtx] = useModal();

    const disabled = !status || status == statusInicial;

    const handleOk = () => {
        if (!status) return;

        modal.confirm({
            title: "Tem certeza?",
            onOk: () => {
                new ViagemService().atualizarStatusDaInscricao(codViagem, codInscricao, status).then(() => {
                    onSuccess?.();
                });
            },
        });
    };

    return (
        <div style={{ padding: 8 }}>
            {modalCtx}
            <Select
                defaultValue={statusInicial}
                style={{ width: "100%", marginBottom: 8 }}
                placeholder="Selecione o novo status"
                onChange={(value) => setStatus(value)}
                options={[
                    { value: EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_INSCRICAO, label: "Aguardando inscrição" },
                    { value: EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_PAGAMENTO, label: "Aguardando pagamento" },
                    { value: EnumStatusDaInscricaoDoAlunoNaViagem.INSCRITO_E_PAGO, label: "Inscrito e pago" },
                    { value: EnumStatusDaInscricaoDoAlunoNaViagem.CANCELADO, label: "Cancelado" },
                ]}
            />

            <Button type="primary" onClick={handleOk} disabled={disabled} style={{ width: "100%" }}>
                Confirmar
            </Button>
        </div>
    );
};

export const InscricoesDaViagem: React.FC<
    ({privilegio: "administrador"} | {privilegio: "escola"}) &
    {
        viagem: TypeViagem,
        retornar?: () => any,
        ocultarDescricao?: boolean
    }
> = (props) => {

    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);
    const tamanhoDaTela = Grid.useBreakpoint();

    const [statusDaModalDeNovasInscricoes, setStatusDaModalDeNovasInscricoes] = useState<{exibir: boolean}>({exibir: false})

    const inscricoesDaViagem = useQuery({
        queryKey: [`viagem/inscricoes/${props.viagem.codigo}`],
        queryFn: async () => {
            const service = new ViagemService();
            const codigoDaViagem = props.viagem.codigo;
            if (codigoDaViagem == undefined) throw new Error();

            const resposta = await service.listarInscricoesDaViagem(codigoDaViagem);
            const inscricoes = resposta.data;
            inscricoes.sort((a, b) => -1 * Ordenar.Data(a.dataDeInscricao, b.dataDeInscricao))
            return inscricoes;
        },
        select(data) {
            data?.forEach(f => f.aluno?.fichasDeSaude?.forEach(fs => {
                if (fs?.ultimaAlteracaoUTC)
                    fs.ultimaAlteracaoUTC = dayjs(fs.ultimaAlteracaoUTC);
                return fs;
            }));

            return data;
        },
        gcTime: 0,
        enabled: true
    })

    interface IFiltro {
        aluno?: TypeInscricaoDoAlunoNaViagem["aluno"],
        status?: TypeInscricaoDoAlunoNaViagem["status"][],
    }

    const novosAlunosAPI = useState<TypeAluno[]>([]);
    const [novosAlunos, setNovosAlunos] = novosAlunosAPI;

    const [form] = useForm<IFiltro>();
    const filtro = useWatch([], form);

    const filterPipe = useCallback((item: TypeInscricaoDoAlunoNaViagem): boolean => {
        const [nomeA, nomeF] = [item.aluno?.pessoa?.nome, filtro?.aluno?.pessoa?.nome]
        return (
            (nomeF == undefined ? true : nomeA?.toLowerCase().includes(nomeF.toLowerCase()) ?? true) &&
            ((filtro?.status == undefined || filtro.status.length == 0) ? true : filtro.status?.find((f) => f == item.status) != undefined)
        )

    }, [filtro]);

    const fecharModalDeInscricoes = useCallback(() => {
        setStatusDaModalDeNovasInscricoes((prev) => ({...prev, exibir: false}));
        setNovosAlunos([]);
    }, [])

    const exibirModalDeInscricoes = useCallback(() => {
        setStatusDaModalDeNovasInscricoes({exibir: true})
    }, [])

    const atualizarInscricoesMutation = useMutation({
        mutationFn: (inscricoes: TypeInscricaoDoAlunoNaViagem[]) => {
            const codigoDaViagem = props.viagem.codigo;
            if (codigoDaViagem == undefined) return Promise.reject("Código da viagem indefinido");

            return new ViagemService().atualizarInscricoesDaViagem(
                codigoDaViagem,
                inscricoes
            )
        },
        onSuccess: () => {
            let mensagem: JSX.Element = <> Inscrições atualizadas com sucesso. </>
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso(mensagem)
            })
        }
    })

    const [chavesDasLinhasExpandidas, setChavesDasLinhasExpandidas] = useState<React.Key[]>([])
    const adicionarAberto = /*props.viagem.alunosInformados == true && */permissoes?.includes(Permissoes.CriarInscricaoDaViagem);

    const viagemRespeitaPrazoMinimo = useMemo((): boolean => {
        if (!props.viagem.fim) return false;

        const fimDate = Formatacoes.paraData(props.viagem.fim);
        if (!fimDate) return false;

        const d = dayjs(fimDate);
        const daysDiff = dayjs().diff(d, "day");

        return daysDiff <= 15;
    }, [props.viagem]);

    const {
        mutate,
        isPending : isPendingPdf
    } = useObterFichaDeSaudeAlunoZip({
        onSuccess(response, variables, context) {
            if (response.status == 204)
            {
                notification.success({
                    ...PropriedadesDeNotificacao["Sucesso"],
                    message: "Estamos processando o arquivo solicitado, logo você receberá um aviso no seu e-mail.",
                    duration: 60
                });
                return;
            }

            const contentDisposition = response.headers['content-disposition'];
            let fileName = `ficha_de_saude_${props?.viagem?.titulo}.zip`;

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="(.+)"/);

                if (fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1];
                }
            }

            saveAs(response.data, fileName);
        },
    });

    return (
        <div>
            <Restrito aberto={props.privilegio === "administrador"}>
                <Modal
                    title={"Adicionar inscrições"}
                    destroyOnClose={true}
                    open={statusDaModalDeNovasInscricoes.exibir == true}
                    width={"80vw"}
                    maskClosable={false}
                    okText="Gravar"
                    okButtonProps={{
                        disabled: novosAlunos.length == 0 || atualizarInscricoesMutation.isPending,
                    }}
                    onCancel={() => {
                        if (novosAlunos.length > 0) {
                            Modal.confirm({
                                title: "Confirmação",
                                content: <>Tem certeza que deseja fechar o painel? Suas alterações não salvas serão perdidas. </>,
                                onOk: fecharModalDeInscricoes,
                            });
                        } else {
                            fecharModalDeInscricoes();
                        }
                    }}
                    onOk={() => {
                        if (props.viagem.codigo == undefined) return;

                        const dataDeInscricao = new Date();
                        const payload: TypeInscricaoDoAlunoNaViagem[] = novosAlunos
                            .filter((a) => a.codigo != undefined)
                            .map((v): TypeInscricaoDoAlunoNaViagem => {
                                return {
                                    aluno: {
                                        codigo: v.codigo,
                                    },
                                    viagem: {
                                        codigo: props.viagem.codigo,
                                    },
                                    status: EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_INSCRICAO,
                                    dataDeInscricao,
                                };
                            });

                        atualizarInscricoesMutation
                            .mutateAsync(payload)
                            .then(() => {
                                fecharModalDeInscricoes();
                                inscricoesDaViagem.refetch();
                            })
                            .catch(() => {});
                    }}
                >
                    <NovasInscricoes
                        formStyle={{ marginTop: "1rem" }}
                        alunosJaInscritos={inscricoesDaViagem.data
                            ?.filter((inscricao) => inscricao.aluno != undefined && inscricao.status != EnumStatusDaInscricaoDoAlunoNaViagem.CANCELADO)
                            .map((inscricao) => inscricao.aluno!)}
                        novosAlunosAPI={novosAlunosAPI}
                    />
                </Modal>
            </Restrito>

            {!props.ocultarDescricao && (
                <React.Fragment>
                    <Collapse
                        accordion
                        bordered={false}
                        items={[
                            {
                                key: "1",
                                label: "Viagem",
                                children: <DescricaoDaViagem viagem={props.viagem} ocultarTitulo />,
                            },
                        ]}
                    ></Collapse>

                    <Divider> Alunos inclusos </Divider>
                </React.Fragment>
            )}

            <Form<IFiltro> form={form} layout="vertical" autoComplete="off">
                <Row gutter={8} about="abcdef">
                    <Col xs={24} lg={14}>
                        <Form.Item<IFiltro> name={["aluno", "pessoa", "nome"]} label="Aluno">
                            <Input placeholder="Todos" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} lg={10}>
                        <Form.Item<IFiltro> name={["status"]} label="Status">
                            <Select
                                allowClear
                                mode="multiple"
                                placeholder={"Todos"}
                                options={StatusDaInscricaoDoAlunoNaViagemLista}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Restrito aberto={adicionarAberto}>
                    <Divider dashed style={{ marginTop: "0" }} />

                    <Row gutter={8}>
                        <Col xs={"auto"}>
                            <Form.Item>
                                <Button type="primary" onClick={exibirModalDeInscricoes}>
                                    Nova inscrição
                                </Button>
                            </Form.Item>
                        </Col>
                        {
                            props?.viagem?.requerFichaDeSaude && <Col xs={"auto"}>
                                <Button type="dashed" icon={<DownloadOutlined />} loading={isPendingPdf} onClick={() => mutate([props.viagem.codigo ?? 0, undefined])}>
                                    Exportar fichas de saúde
                                </Button>
                            </Col>
                        }
                    </Row>
                </Restrito>
            </Form>

            <Row>
                <Col xs={24}>
                    <ResponsiveAntdTable<TypeInscricaoDoAlunoNaViagem, {}>
                        bordered
                        rowKey={(k) => k.codigo!}
                        locale={{ emptyText: "Nenhuma inscrição encontrada." }}
                        loading={inscricoesDaViagem.isFetching}
                        dataSource={inscricoesDaViagem.data?.filter(filterPipe)}
                        disableResponsiveness={true}
                        tableLayout="auto"
                        scroll={{
                            x: true,
                        }}
                        showHeader={true}
                        minColWidthIfResponsivenessDisabled={"120px"}
                        expandable={{
                            showExpandColumn: false,
                            expandedRowRender: (record) => (
                                <React.Fragment>
                                    <Row gutter={[16, 16]}>
                                        <Col xs={24} lg={12}>
                                            {record.aluno == undefined ? (
                                                <Empty description="Nenhum aluno encontrado" />
                                            ) : (
                                                <DescricaoDoAluno aluno={record.aluno} />
                                            )}
                                        </Col>

                                        <Col xs={24} lg={12}>
                                            {((): JSX.Element => {
                                                const responsavelPrincipal = record.aluno?.responsaveis?.find((r) => r.principal == true)?.responsavel;

                                                if (responsavelPrincipal == undefined) {
                                                    return <Empty description="Nenhum responsável marcado como principal encontrado" />;
                                                }

                                                return <DescricaoDoResponsavel responsavel={responsavelPrincipal} />;
                                            })()}
                                        </Col>
                                        {(record?.codTitulo === undefined || record?.codTitulo <= 0) && <></> || <Col xs={24}>
                                            <Divider orientation="left">Forma pagamento</Divider>
                                            <TituloPagamentoListPorTitulo
                                                codTitulo={(record?.codFatura as number)!} 
                                                propsItem={{
                                                    avatar : () => (<div></div>)
                                                }} 
                                            />
                                        </Col>}
                                    </Row>
                                </React.Fragment>
                            ),
                            rowExpandable: () => true,
                            expandedRowKeys: chavesDasLinhasExpandidas,
                        }}
                        columns={[
                            {
                                title: "Aluno",
                                breakpoints: { xs: 24, sm: 8, xl: 5 },
                                key: "aluno-inscricao",
                                dataIndex: ["aluno", "pessoa", "nomeExibicao"],
                                sorter: (a, b) => Ordenar.String(a.aluno?.pessoa?.nome, b.aluno?.pessoa?.nome),
                                render: (_, r) => {
                                    const nome = r?.aluno?.pessoa?.nome;
                                    const nomeSocial = r?.aluno?.pessoa?.nomeSocial;

                                    return (
                                        <>
                                            {nomeSocial && nomeSocial != nome ? (
                                                <>
                                                    {nomeSocial}
                                                    <br/>
                                                    ({nome})
                                                </>
                                            ) : (
                                                <>{nome}</>
                                            )}
                                        </>
                                    );
                                },
                            },
                            {
                                title: "Responsável",
                                breakpoints: { xs: 24, sm: 8, xl: 5 },
                                key: "responsavel-inscricao",
                                sorter: (a, b) => {
                                    let rA = a.aluno?.responsaveis?.find((r) => r.principal == true)?.responsavel.pessoa?.nome;
                                    let rB = b.aluno?.responsaveis?.find((r) => r.principal == true)?.responsavel.pessoa?.nome;

                                    return Ordenar.String(rA, rB);
                                },
                                render: (_, record) => {
                                    return record.aluno?.responsaveis?.find((r) => r.principal == true)?.responsavel.pessoa?.nome ?? "N/A";
                                },
                            },
                            {
                                title: "Status",
                                breakpoints: { xs: 24, sm: 8, xl: 4 },
                                key: "status-inscricao",
                                dataIndex: "status",
                                sorter: (a, b) => Ordenar.Numero(a.status, b.status),
                                render: obterTagDoStatus,
                            },
                            {
                                title: "Ficha de saúde",
                                disabled: props?.viagem?.requerFichaDeSaude ?? false,
                                breakpoints: { xs: 24, sm: 12, xl: 3 },
                                key: "ficha-saude",
                                dataIndex: ["aluno", "fichasDeSaude"],
                                sorter: (a, b) => Ordenar.Data(a.aluno?.fichasDeSaude?.[0]?.ultimaAlteracaoUTC, b.aluno?.fichasDeSaude?.[0]?.ultimaAlteracaoUTC),
                                render(value, record, index) {
                                    const dataFicha = value?.[0]?.ultimaAlteracaoUTC?.format('DD/MM/YYYY');

                                    return dataFicha && record.aluno?.codigo
                                        ? <FichaDeSaudeModal
                                            key={index}
                                            buttonOpen={
                                                <Button type="link" size="small">Preenchida {dataFicha}</Button>
                                            }
                                            fichaProps={{privilegio: "administrador", codigoDoAluno: record.aluno.codigo, permitirCompartilhamento: true}}
                                        />
                                        : undefined;
                                },
                            },
                            {
                                title: "Data de inscrição",
                                breakpoints: { xs: 24, sm: 12, xl: 3 },
                                key: "data-inscricao-inscricao",
                                dataIndex: "dataDeInscricao",
                                sorter: (a, b) => Ordenar.Data(a.dataDeInscricao, b.dataDeInscricao),
                                render: (v) => {
                                    return <>{Formatacoes.paraData(v)?.toLocaleDateString() ?? "N/A"}</>;
                                },
                            },
                            {
                                title: "Data de pagamento",
                                breakpoints: { xs: 24, sm: 12, xl: 3 },
                                key: "data-pagamento-inscricao",
                                dataIndex: "dataDePagamento",
                                sorter: (a, b) => Ordenar.Data(a.dataDePagamento, b.dataDePagamento),
                                render: (v) => {
                                    return <>{Formatacoes.paraData(v)?.toLocaleDateString() ?? "N/A"}</>;
                                },
                            },
                            {
                                title: "Ações",
                                key: "acoes",
                                noResponsiveTitle: true,
                                breakpoints: { xs: 24, sm: 24, xl: 4 },
                                csv: { ignore: true },
                                render: (_, item) => {
                                    const codViagem = item.codViagem ?? item.viagem?.codigo ?? props.viagem?.codigo;

                                    return (
                                        <Conjunto
                                            style={{ justifyContent: tamanhoDaTela.sm ? "unset" : "center", display: "flex", flexWrap: "wrap" }}
                                            itens={[
                                                <Button
                                                    type="dashed"
                                                    size="small"
                                                    icon={item.codigo && chavesDasLinhasExpandidas.includes(item.codigo) ? <MinusOutlined /> : <PlusOutlined />}
                                                    onClick={() => {
                                                        if (!item.codigo) return;

                                                        if (chavesDasLinhasExpandidas.includes(item.codigo)) {
                                                            setChavesDasLinhasExpandidas((prev) => prev.filter((v) => v != item.codigo));
                                                        } else {
                                                            setChavesDasLinhasExpandidas((prev) => [...prev, item.codigo!]);
                                                        }
                                                    }}
                                                ></Button>,

                                                props.privilegio == "administrador" && codViagem && item.codigo && (
                                                    <Dropdown menu={{ items: [
                                                        {
                                                            key: "alterar-status",

                                                            label: <Restrito aberto={permissoes?.includes(Permissoes.Viagem_Inscricao_AlterarStatus)}>
                                                                <Popover
                                                                    destroyTooltipOnHide
                                                                    trigger="click"
                                                                    content={
                                                                        <AlterarStatus
                                                                            codViagem={codViagem}
                                                                            codInscricao={item.codigo}
                                                                            statusInicial={item.status}
                                                                            onSuccess={() => {
                                                                                inscricoesDaViagem.refetch();
                                                                            }}
                                                                        />
                                                                    }
                                                                    placement="topLeft"                                                                    
                                                                >
                                                                    <Button danger style={{ textWrap: "wrap", height: "100%" }}>
                                                                        Alterar status
                                                                    </Button>
                                                                </Popover>
                                                            </Restrito>,
                                                            disabled: !permissoes?.includes(Permissoes.Viagem_Inscricao_AlterarStatus)
                                                        },
                                                        {
                                                            key : "Provedor Pgto.",
                                                            label : <InscricaoProvedorPgtoFormPopConfirm 
                                                                inscricao={{
                                                                    ...item,
                                                                    viagem: props.viagem
                                                                }}
                                                            />,
                                                            disabled: !permissoes?.includes(Permissoes.ViagemInscricaoPagamentoAlterarProvedor)
                                                        },
                                                        {
                                                            key : "gerar-link-pagamento",
                                                            label : <GerarLinkPagamentoFormPopConfirm 
                                                                inscricao={{
                                                                    ...item,
                                                                    viagem: props.viagem
                                                                }}
                                                            />
                                                        }
                                                    ] }}>
                                                        <a onClick={(e) => e.preventDefault()}>
                                                            <Space>
                                                                Ações
                                                                <DownOutlined />
                                                            </Space>
                                                        </a>
                                                    </Dropdown>
                                                ),

                                                props.privilegio == "escola" && item.codAluno && viagemRespeitaPrazoMinimo && (
                                                    <FichaDeSaudeModal
                                                        buttonOpen={
                                                            <Button type="dashed" size="small">
                                                                Ficha de saúde
                                                            </Button>
                                                        }
                                                        fichaProps={{ privilegio: "escola", codigoDoAluno: item.codAluno }}
                                                    />
                                                ),

                                                props.privilegio == "escola" &&
                                                    item.aluno &&
                                                    viagemRespeitaPrazoMinimo &&
                                                    item.codViagem &&
                                                    props.viagem?.requerAutorizacaoParaMenores && (
                                                        <AutorizacaoDaViagemModal
                                                            buttonOpen={
                                                                <Button type="dashed" size="small">
                                                                    Ficha de autorização
                                                                </Button>
                                                            }
                                                            autorizacaoProps={{ privilegio: "escola", aluno: item.aluno, codigoDaViagem: item.codViagem }}
                                                        />
                                                    ),
                                            ]}
                                        />
                                    );
                                },
                            },
                        ].filter(f => f.disabled !== false)}
                        csv={{
                            enabled: true,
                            filename: `inscricoes-viagem-${props.viagem.codigo}.csv`,
                            tryRendered: true
                        }}
                    />
                </Col>
            </Row>

            <Divider style={{ marginTop: 0 }} />

            <Row gutter={16}>
                <Col span={24}>
                    <Flex align="center" justify="center" gap={16}>
                        {props.retornar && (
                            <Button
                                type="dashed"
                                key={"cancel"}
                                onClick={() => {
                                    props.retornar?.();
                                }}
                            >
                                Voltar
                            </Button>
                        )}
                    </Flex>
                </Col>
            </Row>
        </div>
    );

}

export default InscricoesDaViagem
